jQuery(document).ready(function ($) {

    // Only run this script if viewport width is 900px or more
    if (!window.matchMedia('(min-width: 900px)').matches) return;

    // Show button on hover
    $(document)
        .on('mouseenter', '.featured-products-products__card', function () {
            $(this).addClass('with-button');
        })
        .on('mouseleave', '.featured-products-products__card', function () {
            $(this).removeClass('with-button');
        });

});
